import { createGlobalStyle } from "styled-components";
import { fixedFontSizes } from "../Tokens/typography";
import colors from "../Tokens/colors";
import { ThemedProps } from "../Theme/theme";

export const CheckboxTreeStyles = createGlobalStyle`
.react-checkbox-tree {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
      -ms-flex-direction: row-reverse;
          flex-direction: row-reverse;
  font-size: ${fixedFontSizes.baseFontSize}px;
}

.react-checkbox-tree > ol {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
}

.react-checkbox-tree ol {
  margin: 0;
  padding-left: 0;
  list-style-type: none;
}

.react-checkbox-tree ol ol {
  padding-left: 48px;
}

.react-checkbox-tree button {
  line-height: normal;
  
  svg {
    fill: ${(props: ThemedProps) => props.theme.text};
  }
}

.react-checkbox-tree button:focus {
  outline: none;
}

.react-checkbox-tree button:disabled {
  cursor: not-allowed;
}

.react-checkbox-tree .rct-bare-label {
  cursor: default;
}

.react-checkbox-tree label {
  margin-bottom: 0;
  cursor: pointer;
}

.react-checkbox-tree:not(.rct-native-display) input {
  display: none;
}

.react-checkbox-tree.rct-native-display input {
  margin: 0 5px;
}

.react-checkbox-tree .rct-icon {
  display: inline-block;
  text-align: center;
  text-rendering: auto;
  font-family: "Font Awesome 5 Free", "FontAwesome", sans-serif;
  font-weight: normal;
  font-style: normal;
  font-variant: normal;
}

.rct-disabled > .rct-text > label {
  opacity: .75;
  cursor: not-allowed;
}

.rct-disabled > .rct-text > label:hover {
  background: transparent;
}

.rct-disabled > .rct-text > label:active {
  background: transparent;
}

.rct-text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin: 16px 0;
}

.rct-options {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  margin-left: .5rem;
  text-align: right;
}

.rct-option {
  opacity: .75;
  border: 0;
  background: none;
  cursor: pointer;
  padding: 0 4px;
  font-size: 18px;
}

.rct-option:hover {
  opacity: 1;
}

.rct-option + .rct-option {
  margin-left: 2px;
}

.rct-collapse *,
.rct-checkbox *,
.rct-node-icon * {
  display: inline-block;
  margin: 0;
}

.rct-collapse {
  border: 0;
  background: none;
  line-height: normal;
  color: inherit;
  font-size: 12px;
}

.rct-checkbox {
  border: 1px solid ${colors.secondary.gray60};
  background-color: ${colors.primary.white};
  padding: 2px 3px 0;
}

.rct-collapse.rct-collapse-btn {
  cursor: pointer;
}

.rct-collapse > .rct-icon-expand-close {
  opacity: .5;
}

.rct-collapse > .rct-icon-expand-close:hover {
  opacity: 1;
}

.rct-native-display .rct-checkbox {
  display: none;
}

.rct-node-clickable {
  cursor: pointer;
}

.rct-node-clickable:hover {
  background: rgba(51, 51, 204, 0.1);
}

.rct-node-clickable:focus {
  outline: 0;
  background: rgba(51, 51, 204, 0.2);
}

.rct-title {
  padding: 0 5px;
  color: ${(props: ThemedProps) => props.theme.text};
}

.rct-icons-fa4 .rct-icon-expand-close::before {
  content: "\f196";
}

.rct-icons-fa4 .rct-icon-expand-open::before {
  content: "\f147";
}

.rct-icons-fa4 .rct-icon-uncheck::before {
  content: "\f096";
}

.rct-icons-fa4 .rct-icon-check::before {
  content: "\f046";
}

.rct-icons-fa4 .rct-icon-half-check::before {
  opacity: .5;
}

.rct-icons-fa4 .rct-icon-leaf::before {
  content: "\f016";
}

.rct-icons-fa4 .rct-icon-parent-open::before {
  content: "\f115";
}

.rct-icons-fa4 .rct-icon-parent-close::before {
  content: "\f114";
}

.rct-icons-fa4 .rct-icon-expand-all::before {
  content: "\f0fe";
}

.rct-icons-fa4 .rct-icon-collapse-all::before {
  content: "\f146";
}

.rct-icons-fa5 .rct-icon-expand-close::before {
  font-weight: 900;
  content: "\f196";
}

.rct-icons-fa5 .rct-icon-expand-open::before {
  font-weight: 900;
  content: "\f147";
}

.rct-icons-fa5 .rct-icon-half-check::before {
  opacity: .5;
  content: "\f14a";
}

.rct-icons-fa5 .rct-icon-leaf::before {
  content: "\f15b";
}

.rct-icons-fa5 .rct-icon-parent-open::before {
  content: "\f07c";
}

.rct-icons-fa5 .rct-icon-parent-close::before {
  content: "\f07b";
}

.rct-icons-fa5 .rct-icon-expand-all::before {
  content: "\f0fe";
}

.rct-icons-fa5 .rct-icon-collapse-all::before {
  content: "\f146";
}
`;
